export default __webpack_public_path__ + "static/media/importancia_adopciones_responsables_beneficios.41313d41.pdf";